/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.dtp-order.service.ts.
 */
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {interval, Observable} from 'rxjs';
import {DtpZusatzdatentyp} from '../models/dtp-zusatzdatentyp';
import {DtpZusatzdatentypenBlackeningConfigBox} from '../models/dtp-zusatzdatentypen-blackening-config-box';
import {map} from 'rxjs/operators';
import {BestellungEntry} from '../models/bestellung-entry';
import {File} from '../models/file';
import {WarenkorbEntryDtpZusatzdaten} from '../models/warenkorb-entry-dtp-zusatzdaten';
import {BestellungEntryDtpZusatzdaten} from '../models/bestellung-entry-dtp-zusatzdaten';

/**
 * Zweck: Beschreibt class AppDtpOrderService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppDtpOrderService {
  blackeningConfigBoxesMap = {};

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient) {
  }

/**
 * Beschreibt Methode uploadCorrectedDTPZusatezdatenFile und ihren Rückgabevertrag.
 */
  uploadCorrectedDTPZusatezdatenFile(bestellungId, errorId, file: File) {
    const options: any = {
      reportProgress: true,
      observe: 'events',
      headers: new HttpHeaders({ 'ngsw-bypass': 'true' }),
    };

    const formData: FormData = new FormData();
    formData.append('file', file.rawFile);

    return this.http.post<any>(
      '/dtp/defects/' + bestellungId + '/' + errorId,
      formData,
      options
    );
  }

/**
 * Beschreibt Methode saveCorrectedDTPZusatzdatenData und ihren Rückgabevertrag.
 */
  saveCorrectedDTPZusatzdatenData(bestellungId, errorId, data): Observable<WarenkorbEntryDtpZusatzdaten> {
    return this.http.post<WarenkorbEntryDtpZusatzdaten>(
      '/dtp/defects/' + bestellungId + '/' + errorId,
      {
        data: data
      }
    );
  }

/**
 * Beschreibt Methode clearCorrectedDTPZusatzdatenData und ihren Rückgabevertrag.
 */
  clearCorrectedDTPZusatzdatenData(bestellungId, errorId): Observable<WarenkorbEntryDtpZusatzdaten> {
    return this.http.get<WarenkorbEntryDtpZusatzdaten>(
      '/dtp/defects/' + bestellungId + '/' + errorId + '/clear'
    );
  }

/**
 * Beschreibt Methode getDefectList und ihren Rückgabevertrag.
 */
  getDefectList(): Observable<BestellungEntry[]> {
    return this.http.get<BestellungEntry[]>('/dtp/defectList');
  }

/**
 * Beschreibt Methode getDefectById und ihren Rückgabevertrag.
 */
  getDefectById(id): Observable<BestellungEntry> {
    return this.http.get<BestellungEntry>('/dtp/defects/' + id).pipe(map((ret) => {

      Object.setPrototypeOf(ret, BestellungEntry.prototype);
      ret.dtpZusatzdaten.forEach(zd => {
        Object.setPrototypeOf(zd, BestellungEntryDtpZusatzdaten.prototype);
      });
      return ret;
    }));
  }

/**
 * Beschreibt Methode getAdminZusatzdatentypenGeschwaerzt und ihren Rückgabevertrag.
 */
  getAdminZusatzdatentypenGeschwaerzt(): Observable<DtpZusatzdatentyp[]> {
    return this.http.get<DtpZusatzdatentyp[]>(
      '/admin/dtp/zusatzdatentypenGeschwaerzt'
    ).pipe(map((ret) => {
      ret.forEach(r => {
        Object.setPrototypeOf(r, DtpZusatzdatentyp.prototype);
      });
      return ret;
    }));
  }

/**
 * Beschreibt Methode getDtpZusatzdatentypenBlackeningConfigBoxesByMatchcode und ihren Rückgabevertrag.
 */
  getDtpZusatzdatentypenBlackeningConfigBoxesByMatchcode(matchCode: string): Observable<DtpZusatzdatentypenBlackeningConfigBox[]> {
    return new Observable(observer => {
      if (!this.blackeningConfigBoxesMap[matchCode]) {
        this.blackeningConfigBoxesMap[matchCode] = 'Waiting';
        this.http.get<DtpZusatzdatentypenBlackeningConfigBox[]>(
          '/dtp/zusatzdatentypenGeschwaerzt/' + matchCode
        ).pipe(map((ret) => {
          ret.forEach(r => {
            Object.setPrototypeOf(r, DtpZusatzdatentypenBlackeningConfigBox.prototype);
          });
          return ret;
        })).subscribe(ret => {
          this.blackeningConfigBoxesMap[matchCode] = ret;
          observer.next(this.blackeningConfigBoxesMap[matchCode]);
          observer.complete();
        });
      } else {
        if (this.blackeningConfigBoxesMap[matchCode] == 'Waiting') {
          const sub = interval(100).subscribe(x => {
            if (this.blackeningConfigBoxesMap[matchCode] != 'Waiting') {
              observer.next(this.blackeningConfigBoxesMap[matchCode]);
              observer.complete();
              sub.unsubscribe();

            }
          });
        } else {
          observer.next(this.blackeningConfigBoxesMap[matchCode]);
          observer.complete();
        }
      }
    });
  }
}
